@let reviewForm = form();

<div [formGroup]="reviewForm">
  <div class="mb-10">
    <label class="block mb-2 text-sm font-bold text-gray-600"> Suspected items </label>

    <div formArrayName="suspectedItems">
      @for (item of reviewForm.controls.suspectedItems.controls; track item; let i = $index) {
        <div [formGroupName]="i" class="mb-2">
          <div class="flex items-center ps-3 w-full text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg">
            <input
              panCheckbox
              [checked]="selectedItems().has(item.value.id)"
              (change)="toggleItem.emit(item.value.id)"
              id="item-{{ i }}"
              type="checkbox"
              [attr.data-testid]="'suspectedItem' + i"
            />
            <label class="w-full py-3 ms-2 text-sm font-medium text-gray-900" for="item-{{ i }}">
              {{ item.value.description }}: ${{ item.value.total.toFixed(2) }}
            </label>
          </div>
        </div>
      }
    </div>
  </div>
</div>
